export default __webpack_public_path__ + "static/1be5e392-2178-487a-b494-01feab69b4f1-98d9e3401014441b0fc4b22c31018882.woff";